import { ERROR_CODE } from '../constants';

interface UseUnauthorizedResult {
  checkUnauthorized: (URL: string, token: string) => Promise<boolean>;
}

export default function useUnauthorized(
  handleLogoutSecurities?: () => Promise<void>,
): UseUnauthorizedResult {
  const checkUnauthorized = async (
    URL: string,
    token: string,
  ): Promise<boolean> => {
    const httpsUrl = URL.replace('wss://', 'https://');

    try {
      const response = await fetch(httpsUrl, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        if (response.status === ERROR_CODE.UNAUTHORIZED) {
          handleLogoutSecurities?.();
          return true;
        }
        throw new Error(response.statusText);
      }

      return false;
    } catch (err) {
      return false;
    }
  };

  return { checkUnauthorized };
}
